import { useMutation } from '@tanstack/react-query'
import { useApiClientUser } from '~/@api/client/useApiClientUser'
import type { ICreateLogRequest } from '~/@api/generated-api-types-user/Api'

function useLogging() {
  const client = useApiClientUser()

  async function createLog(data: ICreateLogRequest) {
    return client.user
      .logsControllerCreateLog(data, { secure: true })
      .then((resp) => resp.data)
  }

  return useMutation({
    mutationFn: createLog,
  })
}

export { useLogging }
